var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBrickinline = function SvgBrickinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 2.293A.995.995 0 0 0 16 2H8c-.414 0-.785.255-.934.641l-5 13a.999.999 0 0 0 .227 1.066l5 5A.997.997 0 0 0 8 22h8c.414 0 .785-.255.934-.641l5-13a1 1 0 0 0-.227-1.066l-5-5ZM18.585 7h-5.171l-3-3h5.172l2.999 3ZM8.381 4.795l3.438 3.438-4.462 10.71-3.19-3.191L8.381 4.795ZM15.313 20h-6.23l4.583-11h5.878l-4.231 11Z",
    fill: "#fff"
  })));
};

export default SvgBrickinline;